import { RateQuote } from '../rate';

export class RateQuoteResponse {
  id: number;
  rateQuotes: RateQuote[];

  constructor(opts: RateQuoteResponse) {
    this.id = opts.id;
    this.rateQuotes = opts.rateQuotes.map((x) => new RateQuote(x));
  }
}
